import { Component } from '@angular/core';

declare module "@angular/core" {
  interface ModuleWithProviders<T = any> {
      ngModule: Type<T>;
      providers?: Provider[];
  }
}

import { Router } from '@angular/router';
import { AuthenticationService } from './pages/login/authentication.service'
import { User } from './variables/user';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
})
export class AppComponent {
  currentUser: User;

  constructor(
      private router: Router,
      private authenticationService: AuthenticationService
  ) {
      this.authenticationService.currentUser.subscribe(x => this.currentUser = x);
  }

  //logout123() {
   // this.authenticationService.logout();
    //  this.router.navigate(['/login']);
 // }
}
